import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { Hero } from "../components/home/Hero";
import { EditorialMarquee } from "../components/home/Marquee";
import { Problem } from "../components/home/Problem";
import { WhoWeHelp } from "../components/home/WhoWeHelp";
import { Articles } from "../components/home/Articles";
import { Newsletter } from "../components/home/Newsletter";
import { Contact } from "../components/home/Contact";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <EditorialMarquee />
        <Problem />
        <WhoWeHelp />
        <Articles />
        <Newsletter />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
